var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebrtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.14 253.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a9078f8a-2f35-4ddc-9bf0-e15ce72d61aa,.afb417b4-3bab-4814-9f86-6a9c4192582f,.fe67924e-03d5-4ab0-b077-44f32d44e067{fill:#fff;}.a9078f8a-2f35-4ddc-9bf0-e15ce72d61aa{opacity:0.1;}.fe67924e-03d5-4ab0-b077-44f32d44e067{opacity:0.4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ae4afe15-5886-4f3c-b787-576a1c9d2de5",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a09be75c-5299-4f09-b31f-1b9b4818d829",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a9078f8a-2f35-4ddc-9bf0-e15ce72d61aa",
    cx: 126.57,
    cy: 126.57,
    r: 126.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe67924e-03d5-4ab0-b077-44f32d44e067",
    d: "M135.32,161.45a35.79,35.79,0,1,1-35.79-35.79,35.79,35.79,0,0,1,35.79,35.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe67924e-03d5-4ab0-b077-44f32d44e067",
    d: "M206.11,111.35a35.79,35.79,0,1,1-35.79-35.8,35.8,35.8,0,0,1,35.79,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe67924e-03d5-4ab0-b077-44f32d44e067",
    d: "M118.62,110.55A35.79,35.79,0,1,1,82.83,74.76a35.79,35.79,0,0,1,35.79,35.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe67924e-03d5-4ab0-b077-44f32d44e067",
    d: "M190.2,161.45a35.79,35.79,0,1,1-35.79-35.79,35.79,35.79,0,0,1,35.79,35.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe67924e-03d5-4ab0-b077-44f32d44e067",
    d: "M162.36,78.74a35.79,35.79,0,1,1-35.79-35.8,35.79,35.79,0,0,1,35.79,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afb417b4-3bab-4814-9f86-6a9c4192582f",
    d: "M94.27,157H88.68a9,9,0,0,1-9-8.94V97.41a9,9,0,0,1,9-8.94h70.2a9,9,0,0,1,9,8.94v50.68a9,9,0,0,1-9,8.94H135L87,180.55,94.27,157Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebrtc);
export default __webpack_public_path__ + "static/media/webrtc.8fa3aa58.svg";
export { ForwardRef as ReactComponent };